import React from 'react';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';
import FlashCardPage from '../../../subsreens/gcstaff/staffflashcards/FlashCardsPage';



const StaffFlashCardPage = () => {
    return(
       <TeacherMasterLayout>
       <FlashCardPage></FlashCardPage>
       </TeacherMasterLayout>
    )
}

export default StaffFlashCardPage;